import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { UserService } from '../../../Dashboard/_services/users.service';

// Opened from the "Reset your password" email: choose a new password.
@Component({
    selector: 'app-reset-password',
    imports: [FormsModule, RouterLink],
    template: `
  <div class="min-h-screen flex items-center justify-center bg-neutral-100 px-4">
    <div class="w-full max-w-md bg-white rounded-2xl shadow-xl p-8">
      @if (done) {
        <h1 class="text-2xl font-bold text-neutral-800">Password changed</h1>
        <p class="text-sm text-neutral-500 mt-2">Sign in with your new password.</p>
        <a routerLink="/login" class="mt-6 inline-flex px-5 py-2.5 rounded-xl bg-neutral-900 text-amber-400 font-semibold text-sm">Go to sign in</a>
      } @else if (!token) {
        <h1 class="text-2xl font-bold text-neutral-800">This link is incomplete</h1>
        <p class="text-sm text-neutral-500 mt-2">Open the link from the email again, or ask for a new one.</p>
        <a routerLink="/forgot-password" class="mt-6 inline-flex text-sm font-semibold text-amber-700 underline">Forgot password</a>
      } @else {
        <h1 class="text-2xl font-bold text-neutral-800">Choose a new password</h1>
        <p class="text-sm text-neutral-500 mt-1">At least 8 characters.</p>
        <form class="mt-6 space-y-3" (ngSubmit)="save()">
          <input type="password" name="password" autocomplete="new-password" placeholder="New password" [(ngModel)]="password"
            class="w-full rounded-xl border border-neutral-200 px-4 py-3 text-sm focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none" />
          <input type="password" name="confirm" autocomplete="new-password" placeholder="Type it again" [(ngModel)]="confirm"
            class="w-full rounded-xl border border-neutral-200 px-4 py-3 text-sm focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none" />
          @if (error) { <p class="text-sm text-red-600">{{ error }}</p> }
          <button type="submit" [disabled]="busy" class="w-full rounded-xl bg-neutral-900 text-amber-400 font-semibold text-sm py-3 disabled:opacity-60">
            {{ busy ? 'Saving…' : 'Save new password' }}
          </button>
        </form>
      }
    </div>
  </div>`
})
export class ResetPasswordComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private users = inject(UserService);
  token = '';
  password = '';
  confirm = '';
  busy = false;
  done = false;
  error = '';

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token') ?? '';
  }

  save(): void {
    this.error = '';
    if (this.password.length < 8) return void (this.error = 'Use at least 8 characters.');
    if (this.password !== this.confirm) return void (this.error = "The two passwords don't match.");
    this.busy = true;
    this.users.confirmPasswordReset(this.token, this.password).subscribe({
      next: () => {
        this.busy = false;
        this.done = true;
      },
      error: (e) => {
        this.busy = false;
        this.error = e?.error?.message || 'Could not change the password. Please ask for a new link.';
      },
    });
  }
}
